import Help from './Help';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import TitledPanel from './TitledPanel';

class MinorIssues extends React.Component {

    render() {

        const { classes, allowMinorIssues, onChange, margin } = this.props;

        return (
            <TitledPanel title="Data Validation" margin={margin}>
                <FormControl component="fieldset" style={{ marginLeft: 12 }}>
                    <RadioGroup row aria-label="Allow minor issues" name="allowMinorIssues" value={allowMinorIssues.toString()} onChange={onChange}>
                        <FormControlLabel data-test="select-no" value="false" control={<Radio color="primary" />} label="Fail All Errors"
                            classes={{ label: classes.formLabelInline }}
                        />
                        <FormControlLabel data-test="select-yes" value="true" control={<Radio color="primary" />} label="Ignore Minor Errors"
                            classes={{ label: classes.formLabelInline }}
                        />
                    </RadioGroup>
                </FormControl>
                <span style={{ display: 'inline-block', transform: 'translateY(4px)' }}>
                    <Help textRef="MINOR_ISSUES" position={false} />
                </span>
            </TitledPanel>
        );
    }
}

MinorIssues.defaultProps = {
    margin: true
};

MinorIssues.propTypes = {
    allowMinorIssues: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object,
    margin: PropTypes.bool
};

export default withStyles(styles)(MinorIssues);